import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import config from '../../config/app-config';
import { MicroFrontend } from './MicroFrontend';

export const Payment = ({ history }: RouteComponentProps) => (
  <MicroFrontend config={config.microfrontends.payment} history={history} />
);
